import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const customerServiceOrganizationDetailsRoute: InvariantJiraRoute = {
	name: 'customer-service-organization-details',
	path: '/jira/customer-service/organizations/:organizationId',
	exact: true,
};
